"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaAmountToJSON = exports.RosettaAmountFromJSONTyped = exports.RosettaAmountFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaAmountFromJSON(json) {
    return RosettaAmountFromJSONTyped(json, false);
}
exports.RosettaAmountFromJSON = RosettaAmountFromJSON;
function RosettaAmountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': json['value'],
        'currency': _1.RosettaCurrencyFromJSON(json['currency']),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaAmountFromJSONTyped = RosettaAmountFromJSONTyped;
function RosettaAmountToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'value': value.value,
        'currency': _1.RosettaCurrencyToJSON(value.currency),
        'metadata': value.metadata,
    };
}
exports.RosettaAmountToJSON = RosettaAmountToJSON;
//# sourceMappingURL=RosettaAmount.js.map